/*
    Copyright 2022-2026, Techwise Integrated Security, LLC
*/

import { AnyAction, Dispatch } from "@reduxjs/toolkit";
import { Blank, Effect, Pagination, RMA, RMADetailed, Setter } from "../../utils/Interfaces";
import { deleteHandler, getHandler, postHandler, stdErrHandlerFactory } from "../../utils/Requests";
import { AxiosResponse } from "axios";

export function getOpenRMAs(dispatch: Dispatch<AnyAction>, setRMAs: Setter<RMA[]>, setLoading: Setter<boolean>) {
    getHandler<Pagination<RMA>>(
        "/api/rma/list/0",
        dispatch,
        (response: AxiosResponse<Pagination<RMA>, any>) => {
            setRMAs(response.data.results);
        },
        stdErrHandlerFactory(dispatch),
        setLoading
    );
}

export function getArchivedRMAs(dispatch: Dispatch<AnyAction>, setRMAs: Setter<RMA[]>, setLoading: Setter<boolean>) {
    getHandler<Pagination<RMA>>(
        "/api/rma/list/1",
        dispatch,
        (response: AxiosResponse<Pagination<RMA>, any>) => {
            setRMAs(response.data.results);
        },
        stdErrHandlerFactory(dispatch),
        setLoading
    );
}

export function getRMADetails(
    dispatch: Dispatch<AnyAction>,
    rmaId: number,
    setRMA: Setter<RMADetailed>,
    setLoading: Setter<boolean>
) {
    getHandler<RMADetailed>(
        `/api/rma/details/${rmaId}`,
        dispatch,
        (response: AxiosResponse<RMADetailed, any>) => {
            setRMA(response.data);
        },
        stdErrHandlerFactory(dispatch),
        setLoading
    );
}

export function addNoteToRMA(
    dispatch: Dispatch<AnyAction>,
    rmaId: number,
    notes: string,
    onRMANoteAdded: Effect,
    setLoading: Setter<boolean>
) {
    postHandler<{ notes: string }, Blank>(
        `/api/rma/notes/create/${rmaId}`,
        { notes: notes },
        dispatch,
        () => onRMANoteAdded(),
        stdErrHandlerFactory(dispatch),
        setLoading
    );
}

export function editRMANote(
    dispatch: Dispatch<AnyAction>,
    rmaNotesId: number,
    notes: string,
    onRMANoteEdited: Effect,
    setLoading: Setter<boolean>
) {
    postHandler<{ notes: string }, Blank>(
        `/api/rma/notes/edit/${rmaNotesId}`,
        { notes: notes },
        dispatch,
        () => onRMANoteEdited(),
        stdErrHandlerFactory(dispatch),
        setLoading
    );
}

export function deleteRMANote(
    dispatch: Dispatch<AnyAction>,
    rmaNotesId: number,
    onRMANoteDeleted: Effect,
    setLoading: Setter<boolean>
) {
    deleteHandler<Blank>(
        `/api/rma/notes/delete/${rmaNotesId}`,
        dispatch,
        () => onRMANoteDeleted(),
        stdErrHandlerFactory(dispatch),
        setLoading
    );
}

export function editRMA(
    dispatch: Dispatch<AnyAction>,
    rmaId: number,

    title: string,
    description: string,
    partName: string,
    manufacturer: string,
    partNumber: string,
    serialNumber: string,
    storeNumber: string,
    price: number,

    onRMAEdited: Effect,
    setLoading: Setter<boolean>
) {
    postHandler<any, Blank>(
        `/api/rma/edit/${rmaId}`,
        {
            title: title,
            description: description,
            name: partName,
            manufacturer: manufacturer,
            part_number: partNumber,
            serial_number: serialNumber,
            store_number: storeNumber,
            price: price,
        },
        dispatch,
        () => onRMAEdited(),
        stdErrHandlerFactory(dispatch),
        setLoading
    );
}

export function closeRMA(dispatch: Dispatch<AnyAction>, rmaId: number, onRMAClosed: Effect, setLoading: Setter<boolean>) {
    postHandler<Blank, Blank>(
        `/api/rma/close/${rmaId}`,
        {},
        dispatch,
        () => onRMAClosed(),
        stdErrHandlerFactory(dispatch),
        setLoading
    );
}

export function deleteRMA(dispatch: Dispatch<AnyAction>, rmaId: number, onRMADeleted: Effect, setLoading: Setter<boolean>) {
    deleteHandler<Blank>(`/api/rma/delete/${rmaId}`, dispatch, () => onRMADeleted(), stdErrHandlerFactory(dispatch), setLoading);
}
